import { EvidenceLinkType, OpenAiTaskStatus } from './models/enums';

export enum EvidenceType {
  Other = 0,
  Video = 1,
  Audio = 2,
  Document = 3,
  Image = 4,
}

export enum EvidenceStatus {
  Active = 1,
  QueuedForDeletion = 3,
  Deleted = 5,
}

export enum RetainedForTooltipEnum {
  RemovalImminent = 'Removal Imminent.',
  ComingUp = 'Coming Up.',
  AmpleTime = 'Ample Time.',
  EvidenceAlreadyDeleted = 'Evidence Already Deleted.',
  EvidenceWillNotBeDeleted = 'Evidence Will Not Be Deleted.',
}

export enum StatusType {
  Deleted = 'Deleted',
  Retained = 'Retained',
}

export class EvidenceBase {
  constructor(
    public uid: string,
    public recordedOn: Date,
    public uploadedOn: Date,
    public title: string,
    public incidentNumber: string,
    public incidentCadNumber: string,
    public type: EvidenceType,
    public status: EvidenceStatus,
    public officer: EvidenceOfficerBase,
    public thumbnailFullPath: string | null,
    public isLocked: boolean,
    public removeScheduledOn?: Date
  ) {}
}

export class EvidenceBaseWithVideoInfo extends EvidenceBase {
  constructor(
    uid: string,
    recordedOn: Date,
    uploadedOn: Date,
    title: string,
    incidentNumber: string,
    incidentCadNumber: string,
    type: EvidenceType,
    status: EvidenceStatus,
    officer: EvidenceOfficerBase,
    thumbnailFullPath: string | null,
    isLocked: boolean,
    public hasPotentialProcessing: boolean,
    public potentialSummary: string | null,
    public potentialCategories: string | null,
    public aiLabelingStatus: OpenAiTaskStatus,
    public videoInfo?: EvidenceVideoInfo
  ) {
    super(uid, recordedOn, uploadedOn, title, incidentNumber, incidentCadNumber, type, status, officer, thumbnailFullPath, isLocked);
  }
}

export class EvidenceBaseForDeletion extends EvidenceBase {
  constructor(
    uid: string,
    recordedOn: Date,
    uploadedOn: Date,
    title: string,
    incidentNumber: string,
    incidentCadNumber: string,
    type: EvidenceType,
    status: EvidenceStatus,
    officer: EvidenceOfficerBase,
    thumbnailFullPath: string | null,
    isLocked: boolean,
    removeScheduledOn?: Date,
    public isAutoInitiated?: boolean
  ) {
    super(uid, recordedOn, uploadedOn, title, incidentNumber, incidentCadNumber, type, status, officer, thumbnailFullPath, isLocked, removeScheduledOn);
  }
}

export class EvidenceBaseVideoBrowser extends EvidenceBase {
  constructor(
    uid: string,
    recordedOn: Date,
    uploadedOn: Date,
    title: string,
    incidentNumber: string,
    incidentCadNumber: string,
    type: EvidenceType,
    status: EvidenceStatus,
    officer: EvidenceOfficerBase,
    thumbnailFullPath: string | null,
    isLocked: boolean,
    public videoInfo?: EvidenceVideoInfo,
    public categoriesNames?: string[],
    public originalEvidenceName?: string,
    public actualFileDate?: Date,
    public description?: string,
    public storageFileUrl?: string
  ) {
    super(uid, recordedOn, uploadedOn, title, incidentNumber, incidentCadNumber, type, status, officer, thumbnailFullPath, isLocked);
  }
}

export class EvidenceOfficerBase {
  constructor(public uid: string, public firstName: string, public lastName: string, public emailAddress: string, public pictureFullPath: string | null) {}
}

export class EvidenceOfficerBaseResponse {
  constructor(public FirstName: string, public LastName: string, public UID: string, public EmailAddress: string, public PictureFullPath: string | null) {}
}

export class EvidenceVideoInfo {
  constructor(public Duration: number) {}
}

export enum SortEvidenceSearch {
  RecordedOnDesc = 'RecordedOn: desc',
  RecordedOnAsc = 'RecordedOn: asc',
}

export class EvidenceLink {
  constructor(public uid: string, public type: EvidenceLinkType, public source: string, public evidenceName: string) {}
}
